// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"multiselect_checkbox__1HcIg","detailsLink":"multiselect_detailsLink__3Ch8s"};